<template>
  <div id="fazInteraktiv" class="fazInteraktiv" :class="widthClass" ref="fazInteraktiv" v-if="loaded" >
    <div class="header">
      <div class="logo"></div>
      <h2 class="headline">Wie vermögend bin ich?</h2>
      <div class="embed">
        <div @click="toggleEmbed" class="button"><span class="icon"></span>Einbetten</div>
        <div class="box" v-bind:class="{ active: embed }">
          <div class="close" @click="toggleEmbed">×</div>
          Mit diesem Code können Sie die interaktive Grafik in Ihre Website einbetten:
          <pre class="code" id="target">
&lt;link href=https://dynamic.faz.net/red/2020/vermoegensrechner/css/app.css rel=stylesheet&gt;
&lt;div id=app&gt;&lt;/div&gt;
&lt;script src=https://dynamic.faz.net/red/2020/vermoegensrechner/js/app.js&gt;&lt;/script&gt;</pre>
        </div>
      </div>
    </div>
    <div style="overflow: hidden">
      <div class="income-box">
        <div class="income-input-group tab-content column clearfix">
          <div class="frage">
            <h3>Wie alt sind Sie?</h3>
            <select v-model="age">
              <option v-for="el in data.single[0].slice(1)" v-bind:value="el">
                {{el}}
              </option>
            </select>
            <p class="annotation">Alter des Haupteinkommensbeziehers im Haushalt</p>
          </div>

          <div class="frage">
            <h3>Wie hoch ist Ihr Haushaltsnettovermögen?</h3>
            <!-- <input type="number" step="5000" v-model.number="wealth"></input> -->
            <stepper v-model.number="wealth" :stepSize="5000"></stepper>

            <div class="rechenhilfe" v-bind:class="{ active: rechenhilfe }">
              <button v-on:click="toggleRechenhilfe()"><span>+</span> Wir helfen Ihnen beim Rechnen</button>
              
              <div class="extra">
                <div v-for="(asset, index) in assets">
                  <div class="extra-headline">{{asset.name}}</div>
                  <!-- <input type="number" step="100" v-model.number="asset.value"></input> -->
                  <stepper v-if="index<5" v-model.number="asset.value" :stepSize="500"></stepper>
                  <stepper v-else v-model.number="asset.value" :stepSize="500" :color="'red'"></stepper>
                </div>
              </div>
            </div>
          </div>

          <div class="frage">
            <h3>Leben Sie als Single oder als Paar?</h3>
            <label class="radio-element">Haushalt ohne Partner
              <input type="radio" id="single" value="single" v-model="haushalt">
              <span class="checkmark"></span>
            </label>

            <label class="radio-element">Haushalt mit Partner
              <input type="radio" id="paar" value="paar" v-model="haushalt">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      
      <div class="result-box">
        <!-- <div class="satz">Sie gehören zu den vermögendsten <b>40 Prozent</b> in ihrer Altersgruppe.</div> -->
        <!-- <div class="satz">{{satz}}</div> -->
        <div class="chart">
          <div class="chart-header">
            <div class="chart-headline">{{satz}}</div>
            <div class="chart-subheadline">Vermögensverteilung in der Gruppe der {{age}}-Jährigen</div>
          </div>
          <div class="chart-wrapper">
            <lineChart :data="activeData" :wealth="wealth" :domain="domain" v-model="hover" @update-wealth="updateWealth"></lineChart>
            <div class="tooltip" v-if="hover" :style="{'left': hover.x + 'px', 'top': hover.y-15 + 'px'}">
                <em>{{hover.dezil/10}}. Dezil</em><br> {{format(hover.vermoegen)}}€
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="footnote">Grafik: Giesel / Quelle: Institut der Deutschen Wirtschaft, Köln<br>
      <a href="http://www.faz.net/-gpc-a4pzy" title="Woher die Daten kommen">Woher die Daten kommen</a>
    </p>
    
    <div class="empfehlungen">
      <h3>Diese Artikel der F.A.Z. könnten Sie interessieren</h3>
      <div class="artikels">
        <a v-for="artikel in computedArtikels" :href="artikel.url" class="artikel">
          <img :src="'https://www.faz.net/ppmedia/' + artikel.bild + '/media_in_article_medium'" />
          <div class="dachzeile">{{artikel.dachzeile}}</div>
          <div class="headline">{{artikel.titel}}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {csvParse} from 'd3'
import {csvParseRows} from 'd3'
import {format} from 'd3'
// import simpleSelect from 'vue-simple-select'
import pym from 'pym.js'
// import { GChart } from 'vue-google-charts'
import debounce from 'debounce'

import lineChart from './components/line-chart.vue'
import stepper from './components/stepper.vue'

import artikelNeu from './artikel_aktualisiert.js'
import vermoegenData from './data.js'

var pymChild = new pym.Child()

// const clickable = document.querySelector('.click-me');
// clickable.addEventListener('click', () => selectText('target'));

export default {
  name: 'app',
  components: {
    lineChart,
    stepper
    // GChart
    // 'simple-select': simpleSelect
  },
  data () {
    return {
      loaded: false,
      width: null,
      widthClass: 'bpmedium',
      breakpoints: { small: 600, medium: 900},
      singleUrl: process.env.BASE_URL + 'data/single.csv',
      partnerUrl: process.env.BASE_URL + 'data/paar.csv',
      artikelUrl: process.env.BASE_URL + 'data/artikel_aktualisiert.json',
      data: { single: null, paar: null},
      artikel: null,
      age: '50 bis 54',
      haushalt: 'single',
      rechenhilfe: false,
      embed: false,
      wealth: 100000,
      cash: 50000,
      assets: [
        {
          name: "Sparguthaben",
          value: 0
        },
        {
          name: "Immobilien",
          value: 0,
        },
        {
          name: "Bausparguthaben",
          value: 0,
        },
        {
          name: "Wertpapiere",
          value: 0,
        },
        {
          name: "Versicherungen",
          value: 0,
        },
        {
          name: "Hypotheken",
          value: 0,
        },
        {
          name: "Kredite",
          value: 0,
        },
        {
          name: "Ausbildungskredite",
          value: 0,
        }
      ],
      domain: [-30000,450000],
      hover: null,
    }
  },
  methods: {
    parseCsv (csv) {
      return csvParseRows(csv, (d, i) => {
        if(i == 0) {
          return d
        } else {
          return d.map( el => {
            return parseInt(el)
          })
        }
      })
    },
    format (number) {
      if (number == 0) { return '0'}
      return format(",.3r")(number).replace(',','.')
      // return number.toFixed(2).toString().replace('.',',')
      // return number.toString().format(".3n").replace('.',',') //format(",.2r")(
    },
    toggleRechenhilfe () {
      this.rechenhilfe = !this.rechenhilfe
    },
    toggleEmbed () {
      this.embed = !this.embed
      this.selectText('target')
    },
    updateWidth () {
      this.width = this.$refs.fazInteraktiv.getBoundingClientRect().width
    },
    updateWealth (newWealth) {
      this.wealth = newWealth
    },
    selectText (node) {
      node = document.getElementById(node);

      if (document.body.createTextRange) {
          const range = document.body.createTextRange();
          range.moveToElementText(node);
          range.select();
      } else if (window.getSelection) {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(node);
          selection.removeAllRanges();
          selection.addRange(range);
      } else {
          console.warn("Could not select text in node: Unsupported browser.");
      }
    }
  },
  mounted () {
    window.addEventListener('resize', debounce(this.updateWidth, 250))

    this.artikel = artikelNeu
    this.data = vermoegenData
    this.loaded = true

    this.updateWidth()
    // let fetches = [
    //   fetch(this.singleUrl).then(r => r.text()),
    //   fetch(this.partnerUrl).then(r => r.text()),
    //   // fetch(this.artikelUrl).then(r => r.json()),
    // ]
    // Promise.all(fetches).then((results) => {
    //   this.data.single = this.parseCsv(results[0])
    //   this.data.paar = this.parseCsv(results[1])
    //   // this.artikel = results[2]
    //   this.loaded = true
    // })
  },
  updated () {
    this.updateWidth()
    pymChild.sendHeight()
  },
  watch: {
    assets: {
      deep: true,

      handler() {
        let haben = this.assets.slice(0,5).reduce( ( accumulator, currentValue ) => {
          return accumulator + currentValue.value
        }, 0)

        let soll = this.assets.slice(5).reduce( ( accumulator, currentValue ) => {
          return accumulator + currentValue.value
        }, 0)

        this.wealth = haben - soll

        // this.wealth = this.assets.reduce( ( accumulator, currentValue ) => {
        //   return accumulator + currentValue.value
        // }, 0)
      }
    },
    haushalt: function () {
      if (this.haushalt == 'single') {
        this.domain = [-30000,450000]
      } else {
        this.domain = [-100000,860000]
      }
    },
    width: function () {
      if (this.width < this.breakpoints.small) {
        this.widthClass = 'bpsmall' 
      } else if (this.width >= this.breakpoints.small && this.width < this.breakpoints.medium) {
        this.widthClass = 'bpmedium' 
      } else {
        this.widthClass = 'bplarge' 
      }
    },
  },
  computed: {
    activeData: function () {
      let activeIndex = 1
      return this.data[this.haushalt].map( (row, index) => {
        if (index == 0) {
          activeIndex = row.indexOf(this.age)
          return [row[0], row[activeIndex]]
        } else {
          return [row[0], row[activeIndex]]
        }
      })
    },
    dezil: function () {
      let dezil = 0

      this.activeData.forEach( el => {
        if(this.wealth >= el[1]) {
          dezil = el[0]
        }
      })

      return dezil
    },
    satz: function () {
      // this.dezil
      if (this.dezil >= 50) {
        let val = 100-this.dezil
        return 'Sie gehören in Ihrer Altersgruppe zu den reicheren ' + val + ' Prozent.'
      } else if (this.dezil < 50) {
        let val = this.dezil+10
        return 'Sie gehören in Ihrer Altersgruppe zu den ärmeren ' + val + ' Prozent.'
      } else {
        return 'Sie gehören in Ihrer Altersgruppe zur Mittelschicht.'
      }
      
    },
    computedArtikels: function () {
      let filtered = null

      if (this.dezil < 40) {
        filtered = this.artikel.arm
      } else if (this.dezil >= 40 && this.dezil < 80) {
        filtered = this.artikel.mittel
      } else {
        filtered = this.artikel.reich
      }

      if (this.age == "bis 30" || this.age == "30 bis 34" || this.age == "35 bis 39") {
        return filtered.jung
      } else if (this.age == "40 bis 44" || this.age == "45 bis 49" || this.age == "50 bis 54" || this.age == "55 bis 59") {
        return filtered.mittel
      } else {
        return filtered.alt
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './assets/reset.scss';
@import './assets/style.scss';
// @import './assets/select.scss';
</style>
